import { jsx } from "react/jsx-runtime";
import FocusLock from "react-focus-lock";
const FocusTrap = (props) => {
  const { children, style, onEscape, ...otherProps } = props;
  return jsx(FocusLock, { lockProps: {
    tabIndex: 0,
    style: {
      outline: "none",
      ...style
    },
    ...otherProps,
    onKeyDown: (e) => {
      if (e.key === "Escape") {
        onEscape();
        e.stopPropagation();
      }
    }
  }, returnFocus: true, children });
};
export {
  FocusTrap
};
